'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var PinMode = {
  INPUT: 0x00,
  OUTPUT: 0x01,
  ANALOG: 0x02,
  I2C: 0x06
};
var ArduinoBase = /*#__PURE__*/function () {
  function ArduinoBase() {
    (0, _classCallCheck2["default"])(this, ArduinoBase);
    (0, _defineProperty2["default"])(this, "afterReceive", function (data) {
      var _this = this;
      var keys = data.state ? Object.keys(data.state) : [];
      keys.forEach(function (key) {
        return _this.state[key] = data.state[key];
      });
    });
    (0, _defineProperty2["default"])(this, "afterSend", function () {
      Entry.hw.sendQueue = {};
    });
    this.resetState();
  }
  return (0, _createClass2["default"])(ArduinoBase, [{
    key: "setLanguage",
    value: function setLanguage() {
      throw new Error('재정의 필요');
    }
  }, {
    key: "getBlocks",
    value: function getBlocks() {
      throw new Error('재정의 필요');
    }
  }, {
    key: "setZero",
    value: function setZero() {
      this.resetState();
      this.request('reset', null, null, true);
    }
  }, {
    key: "request",
    value: function request(func, subkey, value) {
      var updateNow = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      if (!Entry.hw.sendQueue[func]) Entry.hw.sendQueue[func] = {};
      if (subkey) {
        Entry.hw.sendQueue[func][subkey.toString()] = value;
      } else {
        Entry.hw.sendQueue[func] = value;
      }
      if (updateNow) Entry.hw.update();
    }
  }, {
    key: "resetState",
    value: function resetState() {
      this.state = {
        pin: [],
        rx: {}
      };
    }
  }, {
    key: "pinToNumber",
    value: function pinToNumber(pin) {
      if (pin === undefined || pin === null) return 0;
      if (typeof pin === 'number') {
        if (Number.isNaN(pin)) return 0;
        return pin;
      }
      var pinStr = pin.toString().toLowerCase();
      switch (pinStr) {
        case 'd2':
          return 2;
        case 'd3':
          return 3;
        case 'd4':
          return 4;
        case 'd5':
          return 5;
        case 'd6':
          return 6;
        case 'd7':
          return 7;
        case 'd8':
          return 8;
        case 'd9':
          return 9;
        case 'd10':
          return 10;
        case 'd11':
          return 11;
        case 'd12':
          return 12;
        case 'd13':
          return 13;
        case 'a0':
          return 14;
        case 'a1':
          return 15;
        case 'a2':
          return 16;
        case 'a3':
          return 17;
        case 'a4':
          return 18;
        case 'a5':
          return 19;
        default:
          {
            var n = Number(pin);
            if (Number.isNaN(n)) return 0;
            return n;
          }
      }
    }
  }, {
    key: "isEqualsPinMode",
    value: function isEqualsPinMode(pin, mode) {
      return typeof pin === 'number' && this.state.pin[pin] && this.state.pin[pin].mode == mode;
    }
  }, {
    key: "isDigitalPin",
    value: function isDigitalPin(pin) {
      return typeof pin === 'number' && 2 <= pin && pin <= 15;
    }
  }, {
    key: "isAnalogPin",
    value: function isAnalogPin(pin) {
      return typeof pin === 'number' && 14 <= pin && pin <= 19;
    }
  }, {
    key: "measureAnalogPin",
    value: function measureAnalogPin(pin) {
      var analogPin = pin - 14;
      return Math.min(5, Math.max(0, analogPin));
    }
  }, {
    key: "getDigitalValue",
    value: function getDigitalValue(pin) {
      if (!this.isDigitalPin(pin)) return 0;
      if (!this.isEqualsPinMode(pin, PinMode.INPUT)) {
        this.request('enableDigitalInput', pin, {
          pin: pin
        }, true);
      }
      return this.state.rx.digital && typeof this.state.rx.digital[pin] === 'number' ? this.state.rx.digital[pin] : 0;
    }
  }, {
    key: "getAnalogValue",
    value: function getAnalogValue(pin) {
      var defValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (!this.isAnalogPin(pin)) return defValue;
      if (!this.isEqualsPinMode(pin, PinMode.ANALOG)) {
        this.request('enableAnalogInput', pin, {
          pin: pin
        }, true);
      }
      var analogPin = this.measureAnalogPin(pin);
      return this.state.rx.analog && typeof this.state.rx.analog[analogPin] === 'number' ? this.state.rx.analog[analogPin] : defValue;
    }
  }, {
    key: "set_digital",
    value: function set_digital(sprite, script) {
      var pin = this.pinToNumber(script.getStringValue('PIN'));
      var value = script.getNumberValue('VALUE');
      this.request('setDigital', pin, {
        pin: pin,
        value: value
      });
      return script.callReturn();
    }
  }, {
    key: "set_motor",
    value: function set_motor(sprite, script) {
      var motor = script.getNumberValue('MOTOR');
      var speed = script.getNumberValue('SPEED');
      var state = script.getStringValue('STATE');
      var stateNum = 0;
      if (state == 'cw') stateNum = 1;else if (state == 'ccw') stateNum = 2;
      this.request('setMotor', motor, {
        motor: motor,
        speed: speed,
        state: stateNum
      });
      return script.callReturn();
    }
  }, {
    key: "set_motors",
    value: function set_motors(sprite, script) {
      var motors = script.getNumberValue('MOTORS');
      var speed1 = script.getNumberValue('SPEED1');
      var speed2 = script.getNumberValue('SPEED2');
      var state = script.getStringValue('STATE');
      var speed = [speed1, speed2];
      var motor = [];
      if (motors == 12) {
        motor = [1, 2];
      } else if (motors == 34) {
        motor = [3, 4];
      }
      var stateNum = [0, 0];
      switch (state) {
        case 'forward':
          stateNum = [2, 1];
          break;
        case 'turn-left':
          stateNum = [1, 1];
          break;
        case 'backward':
          stateNum = [1, 2];
          break;
        case 'turn-right':
          stateNum = [2, 2];
          break;
      }
      for (var i = 0; i < 2; i++) {
        this.request('setMotor', i + 1, {
          motor: motor[i],
          speed: speed[i],
          state: stateNum[i]
        });
      }
      return script.callReturn();
    }
  }, {
    key: "set_servo_angle",
    value: function set_servo_angle(sprite, script) {
      var pin = this.pinToNumber(script.getStringValue('PIN'));
      var angle = script.getNumberValue('ANGLE');
      this.request('setServo', pin, {
        pin: pin,
        angle: angle
      });
      return script.callReturn();
    }
  }, {
    key: "set_rgbled_color",
    value: function set_rgbled_color(sprite, script) {
      var pin = this.pinToNumber(script.getStringValue('PIN'));
      var color = Cast.toRgbColorObject(script.getStringValue('COLOR'));
      this.request('setRgbLedColor', pin, {
        pin: pin,
        color: color
      });
      return script.callReturn();
    }
  }, {
    key: "change_rgbled_brightness_by",
    value: function change_rgbled_brightness_by(sprite, script) {
      var pin = this.pinToNumber(script.getStringValue('PIN'));
      var brightness = script.getNumberValue('BRIGHTNESS');
      this.request('changeRgbLedBrightnessBy', pin, {
        pin: pin,
        brightness: brightness
      });
      return script.callReturn();
    }
  }, {
    key: "set_rgbled_brightness_to",
    value: function set_rgbled_brightness_to(sprite, script) {
      var pin = this.pinToNumber(script.getStringValue('PIN'));
      var brightness = script.getNumberValue('BRIGHTNESS');
      this.request('setRgbLedBrightnessTo', pin, {
        pin: pin,
        brightness: brightness
      });
      return script.callReturn();
    }
  }, {
    key: "play_piezobuzzer",
    value: function play_piezobuzzer(sprite, script) {
      var pin = this.pinToNumber(script.getStringValue('PIN'));
      var octave = script.getNumberValue('OCTAVE');
      var duration = script.getNumberValue('DURATION');
      var note = script.getNumberValue('NOTE');
      note = (octave - 1) * 12 + note;
      this.request('setPiezoBuzzer', pin, {
        pin: pin,
        note: note,
        duration: duration
      });
      return script.callReturn();
    }
  }, {
    key: "play_piezobuzzer_until_done",
    value: function play_piezobuzzer_until_done(sprite, script) {
      if (script.executeState) {
        var duration = script.getNumberValue('DURATION') * 1000;
        if (Date.now() - script.executeState.startTime > duration) {
          return script.callReturn();
        } else {
          return script;
        }
      } else {
        script.executeState = {
          startTime: Date.now()
        };
        this.play_piezobuzzer(sprite, script);
        return script;
      }
    }
  }, {
    key: "get_digital_value",
    value: function get_digital_value(sprite, script) {
      var pin = this.pinToNumber(script.getStringValue('PIN'));
      return this.getDigitalValue(pin);
    }
  }, {
    key: "is_digital_detected",
    value: function is_digital_detected(sprite, script) {
      return this.get_digital_value(sprite, script) == 1;
    }
  }, {
    key: "get_analog_value",
    value: function get_analog_value(sprite, script) {
      var pin = this.pinToNumber(script.getStringValue('PIN'));
      return this.getAnalogValue(pin);
    }
  }, {
    key: "compare_analog_value",
    value: function compare_analog_value(sprite, script) {
      var value1 = this.get_analog_value(sprite, script);
      var symbol = script.getStringValue('SYMBOL');
      var value2 = script.getStringValue('VALUE');
      return this._compare(value1, value2, symbol);
    }
  }, {
    key: "_compare",
    value: function _compare(v1, v2, symbol) {
      switch (symbol) {
        case 'greater-than':
          return v1 > v2;
        case 'equal':
          return v1 == v2;
        case 'less-than':
          return v1 < v2;
        default:
          return false;
      }
    }
  }, {
    key: "get_sensor_value",
    value: function get_sensor_value(sprite, script) {
      var pin = this.pinToNumber(script.getStringValue('PIN'));
      var sensor = script.getStringValue('SENSOR');
      if (sensor == 'ultrasonic') {
        if (!this.isEqualsPinMode(pin, PinMode.INPUT)) {
          this.request('enableSonarSensor', pin, {
            pin: pin
          }, true);
        }
        return this.state.rx.digital[pin];
      }
      if (!this.isEqualsPinMode(pin, PinMode.ANALOG)) {
        this.request('enableAnalogInput', pin, {
          pin: pin
        }, true);
      }
      var analogPin = this.measureAnalogPin(pin);
      switch (sensor) {
        case "joystickx":
        case "joysticky":
          {
            var analogValue = this.getAnalogValue(pin, 512);
            var value = analogValue >> 6;
            if (value > 14) return 2;else if (value > 9) return 1;else if (value > 5) return 0;else if (value > 1) return -1;else return -2;
          }
        case "light":
          {
            var _analogValue = this.getAnalogValue(pin);
            return parseInt(Math.round(_analogValue * 0.1));
          }
        case "dial":
          {
            var _analogValue2 = this.getAnalogValue(pin);
            return Math.round(_analogValue2 * 0.1);
          }
        case "akeypad":
          {
            var _analogValue3 = this.getAnalogValue(pin);
            if (_analogValue3 >= 450) return 1;else if (_analogValue3 >= 390) return 2;else if (_analogValue3 >= 310) return 3;else if (_analogValue3 >= 200) return 4;else if (_analogValue3 >= 100) return 5;else return 0;
          }
        case 'temperature':
          {
            if (!this.state.rx.temperature[analogPin] || !this.state.rx.temperature[analogPin].enable) {
              this.request('enableTemperatureSensor', pin, {
                pin: pin
              }, true);
            }
            if (this.state.rx.temperature[analogPin] && this.state.rx.temperature[analogPin].value) {
              return this.state.rx.temperature[analogPin].value;
            }
          }
          break;
        case 'magnetic':
          {
            var _analogValue4 = this.getAnalogValue(pin, 512);
            var zero = 512;
            var zeroGap = 32;
            var startS = zero + zeroGap;
            var startN = zero - zeroGap;
            var maxArea = 64;
            var _value = 0;
            if (_analogValue4 > startS) {
              _value = _analogValue4 > 1024 - maxArea ? 1024 - maxArea : _analogValue4;
              _value = Math.min(10, parseInt(Math.round((_value - startS) / 32)));
            } else if (_analogValue4 < startN) {
              _value = _analogValue4 < maxArea ? maxArea : _analogValue4;
              _value = Math.min(10, parseInt(Math.round((startN - _value) / 32))) * -1;
            }
            return _value;
          }
        case 'rotaryposition':
          {
            if (!this.state.rx.rotaryPosition[analogPin] || !this.state.rx.rotaryPosition[analogPin].enable) {
              this.request('enableRotaryPositionSensor', pin, {
                pin: pin
              }, true);
            }
            if (this.state.rx.rotaryPosition[analogPin] && this.state.rx.rotaryPosition[analogPin].rotation) {
              return this.state.rx.rotaryPosition[analogPin].originAngle;
            }
          }
          break;
      }
      return 0;
    }
  }, {
    key: "compare_sensor_value",
    value: function compare_sensor_value(sprite, script) {
      var value1 = this.get_sensor_value(sprite, script);
      var symbol = script.getStringValue('SYMBOL');
      var value2 = script.getStringValue('VALUE');
      return this._compare(value1, value2, symbol);
    }
  }, {
    key: "get_rotary_position_sensor_value",
    value: function get_rotary_position_sensor_value(sprite, script) {
      var pin = this.pinToNumber(script.getStringValue('PIN'));
      var analogPin = this.measureAnalogPin(pin);
      var type = script.getStringValue('PROPERTY');
      if (!this.state.rx.rotaryPosition[analogPin] || !this.state.rx.rotaryPosition[analogPin].enable) {
        this.request('enableRotaryPositionSensor', pin, {
          pin: pin
        }, true);
      }
      if (!this.state.rx.rotaryPosition[analogPin] || !this.state.rx.rotaryPosition[analogPin].rotation) return 0;
      var obj = this.state.rx.rotaryPosition[analogPin];
      var value = 0;
      switch (type) {
        case 'rotation':
          {
            if (obj.isIntegerRotation) {
              value = parseInt(obj.rotation);
            } else {
              value = obj.rotation;
            }
          }
          break;
        case 'position':
          {
            if (obj.isIntegerPosition) {
              value = parseInt(Math.round(obj.position));
            } else {
              value = obj.position;
            }
          }
          break;
        case 'angle':
          {
            value = obj.angle;
          }
          break;
        case 'angle-origin':
          {
            value = obj.originAngle;
          }
          break;
      }
      return value;
    }
  }, {
    key: "reset_rotary_position_sensor",
    value: function reset_rotary_position_sensor(sprite, script) {
      var pin = this.pinToNumber(script.getStringValue('PIN'));
      var type = script.getStringValue('PROPERTY');
      var value = script.getNumberValue('VALUE');
      this.request('resetRotaryPositionSensor', pin, {
        pin: pin,
        type: type,
        value: value
      });
    }
  }]);
}();
var Cast = /*#__PURE__*/function () {
  function Cast() {
    (0, _classCallCheck2["default"])(this, Cast);
  }
  return (0, _createClass2["default"])(Cast, null, [{
    key: "toRgbColorObject",
    value: function toRgbColorObject(value) {
      var color;
      if (typeof value === 'string' && value.substring(0, 1) === '#') {
        color = Color.hexToRgb(value);

        // If the color wasn't *actually* a hex color, cast to black
        if (!color) color = {
          r: 0,
          g: 0,
          b: 0
        };
      } else {
        color = Color.decimalToRgb(Cast.toNumber(value));
        if (color.hasOwnProperty('a')) {
          delete color.a;
        }
      }
      return color;
    }
  }]);
}();
var Color = /*#__PURE__*/function () {
  function Color() {
    (0, _classCallCheck2["default"])(this, Color);
  }
  return (0, _createClass2["default"])(Color, null, [{
    key: "decimalToHex",
    value: function decimalToHex(decimal) {
      if (decimal < 0) {
        decimal += 0xFFFFFF + 1;
      }
      var hex = Number(decimal).toString(16);
      hex = "#".concat('000000'.substr(0, 6 - hex.length)).concat(hex);
      return hex;
    }
  }, {
    key: "decimalToRgb",
    value: function decimalToRgb(decimal) {
      var a = decimal >> 24 & 0xFF;
      var r = decimal >> 16 & 0xFF;
      var g = decimal >> 8 & 0xFF;
      var b = decimal & 0xFF;
      return {
        r: r,
        g: g,
        b: b,
        a: a > 0 ? a : 255
      };
    }
  }, {
    key: "hexToRgb",
    value: function hexToRgb(hex) {
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
      });
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    }
  }, {
    key: "rgbToHex",
    value: function rgbToHex(rgb) {
      return Color.decimalToHex(Color.rgbToDecimal(rgb));
    }
  }, {
    key: "rgbToDecimal",
    value: function rgbToDecimal(rgb) {
      return (rgb.r << 16) + (rgb.g << 8) + rgb.b;
    }
  }]);
}();
module.exports = {
  ArduinoBase: ArduinoBase,
  PinMode: PinMode,
  Cast: Cast,
  Color: Color
};